export const ROLES = Object.freeze({
    ADMINISTRADOR: 1,
    INSTALADOR: 2,
    SUPERADMIN: 3,
    CLIENTE: 4,
});